// extracted by mini-css-extract-plugin
export default {"normal":"padding-link_normal__KCztT","active":"padding-link_active__C61HC","dark":"padding-link_dark__J+sjY"};